export class CstCustomer {
    custId: string="";
    portfolioId: number;
}